import LazyLoad from 'react-lazyload'

export default function Genre({ data, size = false }) {
    return (
        <div style={{backgroundColor: data.color}} className={`relative overflow-hidden rounded-lg before:block ${size === 'big' ? 'before:h-[220px]' : 'before:pb-[100%]'}`}>
            <span className={`absolute ${size === 'big' ? 'text-[2.5rem]' : 'text-2xl'} font-semibold top-0 left-0 w-full p-4`}>
                {data.name}
            </span>
            <LazyLoad scrollContainer=".main-container" offset={100}>
                <img src={data.last.image} className={`${size === 'big' ? 'w-32 h-32 translate-x-[18%] translate-y-[5%]' : 'w-[6.25rem] h-[6.25rem] translate-x-[18%] translate-y-[10%]'} transform rotate-[25deg] bg-black bg-opacity-10 absolute bottom-0 right-0 shadow-lg`} />
            </LazyLoad>
        </div>
    )
}
